import React, { useState } from 'react'
import { connect } from 'react-redux'
import './checkout-item.styles.scss';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ClearItemFromCart, AddItem, RemoveItem } from '../../../../../redux-store/reducers/cart-reducer/cart.action';
import Naira from 'react-naira'
import * as BiIcons from "react-icons/bi";





const CheckoutItem = ({ cartItem, clearItem, addItem, removeItem, products }) => {
    const { productName, imageId, salesPrice, quantity } = cartItem;
    const [item, setItem] = useState('');
    const [quantityV, setQuantityV] = useState(0);
    function setQuantityValue(e) {

        setItem(e.target.name.split('%')[1])
        addItem(JSON.parse(e.target.name.split('%')[1]), parseFloat(e.target.value), products)
    }

    return (
        <>
            <div className="cart_section container" style={{ width: "79rem", position: "relative", left: "-8rem", }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="cart_container">
                                <div className="cart_items">
                                    <ul className="cart_list">
                                        <li className="cart_item clearfix">
                                            <div className="cart_item_image"> {<img src={cartItem.imageId} alt='item' />}</div>
                                            <div className="cart_item_info d-flex flex-md-row flex-column justify-content-between">
                                                <div className="cart_item_name cart_info_col">
                                                    <div className="cart_item_title font-black text-black"> <strong>Name</strong> </div>
                                                    <div className="cart_item_text">{cartItem.productName}</div>
                                                </div>
                                                <div className="cart_item_quantity cart_info_col">

                                                    <div className="cart_item_title text-black font-black"> <strong>Quantity</strong> </div>
                                                    <div className="cart_item_text">
                                                        <div className='flex flex-row space-x-3'>

                                                            <input className='border-[#3F51B5] border-1 rounded-md px-2 box-border' name={`quantity%${JSON.stringify(cartItem)}`} onChange={setQuantityValue} type="text" placeholder="Qty" />
                                                            <span> <strong>{quantity}</strong> </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="cart_item_price cart_info_col">
                                                    <div className="cart_item_title text-black font-black"> <strong>Price</strong> </div>
                                                    <div className="cart_item_text text-[#3F51B5]"> <strong><Naira>{cartItem.salesPrice}</Naira></strong> </div>
                                                </div>

                                                <div className=" bg-red-500 hover:bg-red-700 transition-colors w-7 h-7 rounded-full items-center justify-center text-center flex" title='Cancel Order'>
                                                    <span onClick={() => clearItem(cartItem)} className='text-white cursor-pointer text-center'> <strong>&#10005;</strong> </span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

const mapToDispatchToProps = (dispatch) => ({
    clearItem: item => dispatch(ClearItemFromCart(item)),//setting the values
    addItem: (item, quantity, products) => {

        dispatch(AddItem(item, !parseFloat(quantity) ? 0 : parseFloat(quantity), products))
    },
    removeItem: item => dispatch(RemoveItem(item))
})

const mapStateToProps = (state) => {
    return {

        products: state.salesReducer.products,
    };
};

//null because we are not getting values
export default connect(mapStateToProps, mapToDispatchToProps)(CheckoutItem);  //connects the component to redux
